export const features = [
  {
    title: "استقرار سریع و آسان",
    desc: "راه‌اندازی سریع با حداقل تداخل در سرویس‌های موجود، توسط تیم آبالون",
    logo: "manage-user.svg",
    imgAlt: "استقرار سریع و آسان",
    imgTitle: "استقرار سریع و آسان",
  },
  {
    title: "پایداری و دسترس‌پذیری بالا",
    desc: "امکان بهره‌مندی از معماری توزیع‌شده برای افزایش تاب‌آوری و تداوم سرویس‌ها",
    logo: "leak.svg",
    imgAlt: "پایداری و دسترس‌پذیری بالا",
    imgTitle: "پایداری و دسترس‌پذیری بالا",
  },
  {
    title: "پنل مدیریتی پیشرفته",
    desc: "دسترسی به پنل مدیریتی یکپارچه برای مدیریت ساده و دقیق همه سرویس‌ها",
    logo: "impersonate.svg",
    imgAlt: "پنل مدیریتی پیشرفته",
    imgTitle: "پنل مدیریتی پیشرفته",
  },
  {
    title: " پشتیبانی تخصصی ۲۴/۷",
    desc: "نظارت و پشتیبانی شبانه‌روزی با رویکرد پیشگیرانه توسط تیم‌های فنی آبالون",
    logo: "users.svg",
    imgAlt: " پشتیبانی تخصصی ۲۴/۷",
    imgTitle: " پشتیبانی تخصصی ۲۴/۷",
  },
];

export const solutions = [
  {
    img: "container.svg",
    name: "رایانش ابری",
    desc: "رایانش ابری به‌عنوان بخشی از محصولات آبالون، مجموعه‌ای از سرویس‌های پردازشی و زیرساختی شامل سرورهای ابری و دیتاسنتر ابری مقیاس‌پذیر است. این سرویس‌ها با پشتیبانی شبانه‌روزی، امکان دسترسی پایدار و مطمئن از داخل ایران و خارج از کشور را برای اجرای سرویس‌ها، توسعه نرم‌افزارها و مدیریت منابع سازمانی شما در بستر ابر ایجاد می‌کنند.",
    alt: "رایانش ابری",
    title: "رایانش ابری",
    link: "/compute",
    linkTitle: "آشنایی با رایانش ابری آبالون",
    linkText: "رایانش ابری آبالون",
  },

  {
    img: "Isolation.svg",
    name: "شبکه توزیع محتوا (CDN‌)",
    desc: "سرویس CDN به‌عنوان بخشی از مجموعه محصولات آبالون، با پاپ‌سایت‌های گسترده در سراسر ایران و پنج قاره جهان، محتوای وب‌سایت و سرویس‌های آنلاین سازمان شما را با سرعت بالا، تأخیر کم و امنیت کامل به کاربران ارائه می‌دهد. این سرویس ضمن بهینه‌سازی مصرف منابع و پهنای باند، از وب‌سایت شما در برابر تهدیدات سایبری مانند حملات DDoS محافظت کرده و مدیریت دامنه‌ها و محتوا را ساده‌تر می‌کند.",
    alt: "شبکه توزیع محتوا (CDN‌)",
    title: "شبکه توزیع محتوا (CDN‌)",
    link: "/cdn",
    linkTitle: "آشنایی با شبکه توزیع محتوا آبالون",
    linkText: "شبکه توزیع محتوا آبالون",
  },
  {
    img: "plans.svg",
    name: "خدمات دیتاسنتر",
    desc: "با خدمات دیتاسنتر آبالون، بدون دغدغه‌ی تامین برق پایدار، سرمایش پیشرفته و پهنای باند پرسرعت، زیرساختی امن و کارآمد در اختیار خواهید داشت. می‌توانید منابع سخت‌افزاری اختصاصی داشته باشید یا تجهیزات سازمانی خود را در محیطی پایدار و تحت مدیریت آبالون مستقر کنید. سرویس‌های سرورهای اختصاصی و سرویس کولوکیشن این امکان را فراهم می‌کنند تا معماری ابری را بر بستر تجهیزات سازمانی خود یا منابع اختصاصی آبالون تجربه کنید.",
    alt: "خدمات دیتاسنتر",
    title: "خدمات دیتاسنتر",
    link: "/datacenter-services",
    linkTitle: "آشنایی با خدمات دیتاسنتر آبالون",
    linkText: "خدمات دیتاسنتر آبالون",
  },
  {
    img: "HA.svg",
    name: "پایداری داده",
    desc: "راهکارهای پایداری داده به‌عنوان بخشی از محصولات آبالون، مجموعه‌ای کامل از سرویس‌های پیشرفته شامل ذخیره‌سازی (آبجکت استوریج)، پشتیبان‌گیری و بازیابی از (DR) است. این بستر  به شما امکان می‌دهد از تدوام عملکرد سرویس‌ها و حفظ داده خود در برابر خرابی سخت‌افزار، حملات سایبری، خطاهای انسانی یا به‌روزرسانی‌های ناموفق محافظت کنید.",
    alt: "پایداری داده",
    title: "پایداری داده",
    link: "/data-resilience",
    linkTitle: "آشنایی با راهکار پایداری داده‌ها آبالون",
    linkText: "پایداری داده‌ها آبالون",
  },
  {
    img: "service.svg",
    name: "شبکه ابری",
    desc: "شبکه ابری به‌عنوان بخشی از مجموعه محصولات آبالون، به سازمان‌ها امکان مدیریت بهینه ترافیک و دسترسی بدون محدودیت به منابع داخلی و بین‌المللی را می‌دهد. این سرویس شامل لود بالانسر هوشمند برای توزیع پایدار و سریع ترافیک و تحریم‌شکن اختصاصی برای دسترسی امن به منابع بین‌المللی است. با شبکه ابری آبالون، زیرساخت سازمان شما همواره پایدار، امن و در دسترس باقی می‌ماند.",
    alt: "شبکه ابری",
    title: "شبکه ابری",
    link: "/network",
    linkTitle: "آشنایی با شبکه ابری آبالون",
    linkText: "شبکه ابری آبالون",
  },
];

export const popularServices = [
  {
    title: "راهکارهای تخصصی آبالون",
    desc: "با راهکارهای تخصصی آبالون، بدون پیچیدگی فنی، مسیر مهاجرت، مدیریت و امنیت ابری را ساده‌تر کنید و سازمان‌تان را در مسیر رشد و تحول دیجیتال پیش ببرید.",
    logo: "VPS-Service.svg",
    route: "/solutions",
  },
  {
    title: "امنیت مهاجرت ابری",
    desc: "با راهکار مهاجرت ابری، زیرساخت‌های سنتی یا مونولیتیک خود را به‌صورت گام‌به‌گام و با حداقل اختلال در عملیات جاری به محیط ابری منتقل کنید.",
    logo: "ManagedService-Service.svg",
    route: "/cloud-migration",
  },
  {
    title: "راهکارهای سازمانی",
    desc: "با شبکه ابری آبالون، ترافیک سازمان‌تان را بهینه مدیریت کنید، محدودیت‌های دسترسی را برطرف کنید و اتصال پایدار و امن را تجربه کنید.",
    logo: "VPC-Service.svg",
    route: "/enterprise-solutions",
  },
  {
    title: "امنیت ابری",
    desc: "با استفاده از راهکارهای امنیتی پیشرفته مانند فضای کاری امن، فایروال ابری، WAF و سامانه SIEM از سرویس‌های سازمانی خود در فضای ابری محافظت کنید.",
    logo: "CloudGuard-Service.svg",
    route: "/cloud-security",
  },
];

export const questions = [
  {
    title: "محصولات آبالون کدام بخش‌های راهکارهای ابری را پوشش می‌دهند؟",
    answer:
      "محصولات آبالون مجموعه‌ای از ابزارها و راهکارهای پیشرفته ابری هستند که به سازمان‌ها کمک می‌کنند فرایندها را ساده‌تر مدیریت کنند، امنیت و پایداری را افزایش دهند و بهینه‌ترین معماری‌ ابری را تجربه کنند. این محصولات شامل سرویس‌های پردازشی و زیرساختی مانند سرورهای ابری و دیتاسنتر ابری مقیاس‌پذیر، شبکه توزیع محتوا (CDN) برای بهبود سرعت و امنیت محتوای وب‌سایت و سرویس‌های آنلاین، خدمات دیتاسنتر شامل سرور اختصاصی و کولوکیشن، راهکارهای پایداری داده شامل ذخیره‌سازی (آبجکت استوریج)، پشتیبان‌گیری و بازیابی از بحران (DR) و شبکه ابری با مدیریت بهینه ترافیک و دسترسی بدون محدودیت به منابع داخلی و بین‌المللی (تحریم‌شکن) می‌شوند.",
  },
  {
    title:
      "محصولات آبالون چگونه به افزایش سرعت و عملکرد فرآیندهای سازمانی کمک می‌کنند؟",
    answer:
      "محصولات آبالون با فراهم کردن منابع پردازشی و ذخیره‌سازی سریع و مقیاس‌پذیر، امکان اجرای بلادرنگ و بدون وقفه سرویس‌ها و برنامه‌های سازمانی را ایجاد می‌کنند. شبکه توزیع محتوا (CDN) سرعت دسترسی به داده‌ها و سرویس‌های آنلاین را افزایش می‌دهد، شبکه ابری اختصاصی ترافیک را بهینه مدیریت می‌کند و ارتباط پایدار میان شعب و دفاتر سازمان را برقرار می‌کند. علاوه بر این، راهکارهای پایداری داده و خدمات دیتاسنتر، اطمینان می‌دهند که فرآیندها در برابر خرابی سخت‌افزار، خطاهای انسانی یا حملات سایبری دچار وقفه نشوند، تا عملکرد سازمان همیشه پایدار و سریع باقی بماند.",
  },
  {
    title:
      "محصولات آبالون چگونه امنیت داده‌ها و سرویس‌های سازمان را بدون نیاز به تجهیزات سخت‌افزاری فراهم می‌آورند؟",
    answer:
      "شبکه توزیع محتوا (CDN) آبالون نه‌تنها سرعت دسترسی به محتوا را افزایش می‌دهد، بلکه با مکانیزم‌های پیشرفته امنیتی از داده‌ها و سرویس‌های شما در برابر حملات سایبری مانند DDoS محافظت می‌کند. راهکارهای پایداری داده شامل آبجکت استوریج، بکاپ سرور ابری و بازیابی از بحران (DR) از اطلاعات شما در برابر خرابی سخت‌افزار، خطاهای انسانی و حملات سایبری محافظت می‌کنند. علاوه بر این، شبکه اختصاصی و ایزوله نورونتا و خدمات دیتاسنتر، دسترسی امن و پایدار به سرویس‌ها و ارتباط داخلی میان شعب و دفاتر سازمان را تضمین می‌کنند و امنیت چندلایه را بدون پیچیدگی‌های فنی برای سازمان فراهم می‌آورند.",
  },
  {
    title:
      "محصولات آبالون در بخش ذخیره‌سازی چه امکاناتی در اختیار سازمان‌ها قرار می‌دهند؟",
    answer:
      "محصولات آبالون در بخش ذخیره‌سازی، امکانات جامعی برای مدیریت داده‌های سازمانی ارائه می‌دهند. این سرویس‌ها شامل آبجکت استوریج برای داده‌های حجیم، بکاپ ابری برای نسخه‌های پشتیبان زمان‌بندی‌شده و بازیابی از بحران (DR) برای اطمینان از تداوم سرویس‌های سازمان در شرایط بحران هستند. با این امکانات، سازمان‌ها می‌توانند بدون نیاز به تجهیزات سخت‌افزاری اضافی، داده‌ها و سرویس‌های حیاتی خود را در برابر خرابی سخت‌افزار، خطاهای انسانی، حملات سایبری یا به‌روزرسانی‌های ناموفق محافظت کرده و دسترسی پایدار و امن به اطلاعات داشته باشند.",
  },
];
